import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';
import { OPEN_BID_LIMIT_EXCEEDED_MODAL } from './actions';

/* reducer */
const DEFAULT_STATE = {
    catalogId: 0,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case OPEN_BID_LIMIT_EXCEEDED_MODAL:
            return {
                ...state,
                catalogId: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidLimitExceeded;

export const getBidLimitExceededCatalogId = createSelector(stateSelector, (state) => state.catalogId);
